import { render } from "./SchedulesExpansionBody.vue?vue&type=template&id=cf85779c&scoped=true"
import script from "./SchedulesExpansionBody.vue?vue&type=script&lang=js"
export * from "./SchedulesExpansionBody.vue?vue&type=script&lang=js"

import "./SchedulesExpansionBody.vue?vue&type=style&index=0&id=cf85779c&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf85779c"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QList,QItem,QItemSection,QItemLabel,QIcon});qInstall(script, 'directives', {Ripple});
